const urls = {
  ui: {
    workspace: (slug: string) => `/${slug}`,
    settings: (slug: string) => `${urls.ui.workspace(slug)}/workspace/settings`,
    planUsersLink: (owner: string) => `/${owner}/workspace/settings/plan-users`,
    groupSettings: (slug: string) => `${urls.ui.settings(slug)}/groups`,
  },
  api: {
    internal: {
      invitationRestrictions: (slug: string) =>
        `/!api/internal/workspaces/${slug}/invitation-restrictions/`,
      accessTokens: (slug: string): string =>
        `/!api/internal/workspaces/${slug}/access-tokens`,
      accessTokensPolicy: (slug: string): string =>
        `/!api/internal/workspaces/${slug}/access-tokens-policy`,
    },
  },
  external: {
    learnMoreAboutGroupsLink:
      'https://support.atlassian.com/bitbucket-cloud/docs/organize-workspace-members-into-groups/',
  },
};

export default urls;
